import {WorkflowStep} from "../../enums/WorkflowStep";
import {WorkflowInstanceModel} from "../workflow/workflow-instance.model";

import {WorkflowInstanceStepCommentModel} from './workflow-instance-step-comment.model';

export const WorkFlowStepClass = {
  WorkflowStepPreparationModel: 'WorkflowStepPreparationModel',
  WorkflowStepSampleSelectionModel: 'WorkflowStepSampleSelectionModel',
  WorkflowStepDnaExtractionModel: 'WorkflowStepDnaExtractionModel',
  WorkflowStepDnaExtractionSwabLysisModel: 'WorkflowStepDnaExtractionSwabLysisModel',
  WorkflowStepAddingChecksModel: 'WorkflowStepAddingChecksModel',
  WorkflowStepQuantificationFirstModel: 'WorkflowStepQuantificationFirstModel',
  WorkFlowStepTargetPcrModel: 'WorkFlowStepTargetPcrModel',
  WorkflowStepMeasurementOnGlomaxFirstModel: 'WorkflowStepMeasurementOnGlomaxFirstModel',
  WorkflowStepNormalisationPreparationModel: 'WorkflowStepNormalisationPreparationModel',
  WorkflowStepNormalisation: 'WorkflowStepNormalisation',
  WorkflowStepTargetPoolingModel: 'WorkflowStepTargetPoolingModel',
  WorkflowStepPurificationModel: 'WorkflowStepPurificationModel',
  WorkflowStepIndexPcrSetupModel: 'WorkflowStepIndexPcrSetupModel',
  WorkflowStepLibraryPlateSelectionModel: 'WorkflowStepLibraryPlateSelectionModel',
  WorkflowStepQuantificationSecondModel: 'WorkflowStepQuantificationSecondModel',
  WorkflowStepMeasurementOnGlomaxSecondModel: 'WorkflowStepMeasurementOnGlomaxSecondModel',
  WorkflowStepLibraryNormalisationAndPooling: 'WorkflowStepLibraryNormalisationAndPooling',
  WorkflowStepLibraryIndexPurificationModel: 'WorkflowStepLibraryIndexPurificationModel',
  WorkflowStepLibraryAgilantModel: 'WorkflowStepLibraryAgilantModel',
  WorkflowStepLibraryQubitModel: 'WorkflowStepLibraryQubitModel',
  WorkflowStepLibraryNgsSequencingModel: 'WorkflowStepLibraryNgsSequencingModel',
  WorkflowStepLibraryPostSequencingModel: 'WorkflowStepLibraryPostSequencingModel',
  WorkflowStepReviewModel: 'WorkflowStepReviewModel',
  WorkflowStepFinishedModel: 'WorkflowStepFinishedModel'
}

export interface IWorkflowStepBase {

  id: number;
  step: WorkflowStep;
  workflowInstance: WorkflowInstanceModel;
  isSkipped: boolean;

  comment?: WorkflowInstanceStepCommentModel;

}
